/**
 *  Industry on click.
 *
 * @package Embark
 * @since   1.0.0
 */

// Define our comment reply funciton.
const emInitIndustries = () => {
	const industries = document.querySelectorAll('.divisions .image');

	industries.forEach( ( ind, i ) => {
		ind.onclick = e => {
			industries.forEach( ind => {
				ind.classList.remove('active');
			});
			ind.classList.add('active');
		}
	});

};

document.addEventListener('DOMContentLoaded', () => {
	emInitIndustries();
});
